import { render, staticRenderFns } from "./FolderCreateForm.vue?vue&type=template&id=ac40f234"
import script from "./FolderCreateForm.vue?vue&type=script&lang=js"
export * from "./FolderCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports